module.exports = __webpack_public_path__ + "static/media/INVESTOR.e52e9d72.svg";